// ============================================================================
// COMPONENTE: InstallPWABanner.jsx — A4
// Banner "Adicionar à tela inicial" — captura evento beforeinstallprompt e
// exibe banner mobile estilizado. Ignorado se usuário dispensar.
// ============================================================================

import React, { useEffect, useState } from 'react';
import { X, Smartphone } from 'lucide-react';

const LS_KEY = 'rda_pwa_banner_dismissed';

export default function InstallPWABanner() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible]               = useState(false);

  useEffect(() => {
    try { if (localStorage.getItem(LS_KEY)) return; } catch {}

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setVisible(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      try { localStorage.setItem(LS_KEY, '1'); } catch {}
    }
    setVisible(false);
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    try { localStorage.setItem(LS_KEY, '1'); } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-3 md:hidden">
      <div className="bg-[#20243B] border border-[#C5A059]/40 rounded-xl shadow-2xl px-4 py-3 flex items-center gap-3">
        <div className="shrink-0 h-9 w-9 rounded-lg bg-[#C5A059]/15 border border-[#C5A059]/30 flex items-center justify-center">
          <Smartphone className="w-4 h-4 text-[#C5A059]" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-xs font-bold text-white leading-tight">Adicionar à tela inicial</div>
          <div className="text-[10px] text-gray-400 mt-0.5">Acesse o portal como um aplicativo</div>
        </div>
        <button
          type="button"
          onClick={handleInstall}
          className="shrink-0 px-3 py-1.5 rounded-lg bg-[#C5A059] text-[#20243B] text-[11px] font-extrabold uppercase tracking-wide"
        >
          Instalar
        </button>
        <button
          type="button"
          onClick={handleDismiss}
          className="shrink-0 h-7 w-7 rounded-full flex items-center justify-center text-gray-400 hover:text-white"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
